import React, { useEffect, useState } from "react";
import { AiOutlineArrowRight,AiOutlineReload,AiOutlineCheck } from "react-icons/ai";
import { 
    DefaultButton, 
    SearchBox,
    Spinner,
 } from "@fluentui/react";
import OrdersListItem from "./OrderListItem";
import { dashboardApi } from "../../api/dashboardApi";

const OrdersList = ({data, onSelect}:any) => {
    const [selectedTab, setSelectedTab] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [tankOrders, setTankOrders] = useState<any>([]);
    const [truckOrders, setTruckOrders] = useState<any>([]);
    const [railOrders, setRailOrders] = useState<any>([]);

    const fetchOrders = async()=>{
        setIsLoading(true);
        const body={
            pageNo:1,
            keyword:"",
            pageSize:15,
            salesOrg:"PHL",
            modality:selectedTab,
        }
        const response= await dashboardApi.getOrderList(body);
        if(response){
            if(selectedTab===0){
                setTankOrders(response?.results);
            }else if(selectedTab===1){
                setTruckOrders(response?.results);
            }else{
                setRailOrders(response?.results);
            }
        }
        setIsLoading(false);
    }
    
    useEffect(()=>{
        if(selectedTab===0 && tankOrders.length===0){
            fetchOrders();
        }else if(selectedTab===1&& truckOrders.length===0){
            fetchOrders();
        }else if(selectedTab===2&& railOrders.length===0){
            fetchOrders();
        }
    },[selectedTab])

    return (
        <div className="ongoing-orders-card">
            <div className="header">
                <h3>Ongoing Orders</h3>
                <div className="tabs">
                    <DefaultButton className={selectedTab===0?"active-tab":"tab"} onClick={()=>setSelectedTab(0)}>Tank</DefaultButton>
                    <DefaultButton className={selectedTab===1?"active-tab":"tab"} onClick={()=>setSelectedTab(1)}>Truck</DefaultButton>
                    <DefaultButton className={selectedTab===2?"active-tab":"tab"} onClick={()=>setSelectedTab(2)}>Rail</DefaultButton>
                </div>
            </div>
            {/* <SearchBox placeholder="Search" className="searchbar"/> */}
            <div className="list">
                {isLoading&&(
                    <Spinner/>
                )}
                {selectedTab===0?(
                    tankOrders.length===0&&!isLoading?(<p>No Orders</p>):
                    (
                        tankOrders?.slice(0,5).map((t:any)=>
                            <OrdersListItem data={t} type={selectedTab} onSelect={onSelect}/>
                    )
                )
                ):selectedTab===1?(
                    truckOrders.length===0&&!isLoading?(<p>No Orders</p>):
                    (truckOrders?.map((t:any)=>
                        <OrdersListItem data={t} type={selectedTab} onSelect={onSelect}/>
                    ))
                ):(
                    railOrders.length===0&&!isLoading?(<p>No Orders</p>):
                    (railOrders?.slice(0,5).map((t:any)=>
                        <OrdersListItem data={t} type={selectedTab} onSelect={onSelect}/>
                    ))
                )}
            </div>
        </div>
    )
}

export default OrdersList;